import dispatchEvent from '../utils/dispatch-event.js';
import EVENT from '../enums/event.js';
import STATE from '../enums/state.js';

const classes = {
  hide: 'invisible',
  overflowHidden: 'overflow-hidden',
};

class PageOverlay {
  /**
   * @param {Element} element
   */
  constructor(element) {
    this.overlay = element;

    this.registerEventListeners();
  }

  /**
   * @return {'inactive'|'active'}
   */
  get state() {
    return this.overlay.dataset.state;
  }

  set state(state) {
    this.overlay.dataset.state = state;
  }

  registerEventListeners() {
    this.overlay.addEventListener('click', () => {
      dispatchEvent(EVENT.DRAWER.TOGGLE, this.overlay, {
        detail: {
          drawer: this.overlay,
        },
      });
    });

    document.addEventListener(EVENT.OVERLAY.ACTIVATE, () => this.activate());
    document.addEventListener(EVENT.OVERLAY.DEACTIVATE, () =>
      this.deactivate()
    );
  }

  deactivate() {
    this.overlay.classList.add(classes.hide);
    this.overlay.classList.remove('visible');
    document.body.classList.remove(classes.overflowHidden);

    this.state = STATE.OVERLAY.INACTIVE;
  }

  activate() {
    this.overlay.classList.remove(classes.hide);
    this.overlay.classList.add('visible');
    document.body.classList.add(classes.overflowHidden);

    this.state = STATE.OVERLAY.ACTIVE;
  }
}

const createOverlay = element => new PageOverlay(element);

export default createOverlay;
